module.exports = "/src/views/casino/jacpot/logo.svg";